module.exports = __webpack_public_path__ + "img/mo_super04.eeed2d1c.png";